import { Header } from "components/atoms/Typography";
import { LeafIcon, HandHoldingMoneyIcon } from "components/atoms/Icon";
import { MeasureAnnualCashFlowChartRecommendations } from "components/organisms/Charts/Recommendations/AnnualCashFlowChartRecommendations";
import ImpactCard from "./Cards/ImpactCard";
import ProjectCardSection from "./Cards/ProjectCardSection";

function TotalCostAndSavingsCard({
    measure,
    measureAnalysis,
}: {
    measure: CarbonReductionMeasure;
    measureAnalysis: MeasureAnalysis;
}) {
    const titleSectionSavings = {
        key: "netSavings",
        humanReadableOverride: "Net savings",
        icon: <LeafIcon />,
        value: measureAnalysis.splitNetSavings,
    };
    const bodySectionSavings = [
        {
            key: "totalUtilityCostSavingsElectricity",
            value: measureAnalysis.splitElectricityUtilityCostSavings,
        },
        {
            key: "totalUtilityCostSavingsNaturalGas",
            value: measureAnalysis.splitNaturalGasUtilityCostSavings,
        },
        {
            key: "totalCarbonPolicyCostSavings",
            value: measureAnalysis.totalCarbonCostSavingsAll,
        },
        {
            key: "revenue",
            value: measureAnalysis.revenue,
        },
    ];
    const titleSectionCost = {
        key: "netCost",
        humanReadableOverride: "Net cost",
        icon: <HandHoldingMoneyIcon />,
        value: measureAnalysis.splitNetCost,
    };
    const bodySectionCost = [
        {
            key: "implementationCost",
            value: measureAnalysis.splitImplementationCost,
        },
        {
            key: "totalIncentives",
            value: measureAnalysis.incentives,
        },
    ];

    return (
        <div className="large-card">
            <Header size="small">Costs & savings</Header>
            <ProjectCardSection
                key="netSavings"
                data={{
                    title: titleSectionSavings,
                    body: bodySectionSavings,
                }}
            />
            <ProjectCardSection
                key="totalMeasureCost"
                data={{
                    title: titleSectionCost,
                    body: bodySectionCost,
                }}
            />
        </div>
    );
}

function MeasureAnalysisSetting({ title, value, hidden }: { title: string; value: any; hidden?: boolean }) {
    const style = {
        padding: "10px",
        display: hidden === true ? "none" : "block",
    };
    return (
        <p style={style}>
            {title}: {value}
        </p>
    );
}

function MeasureAnalysis({
    measureAnalysis,
    measure,
}: {
    measureAnalysis: MeasureAnalysis;
    measure: CarbonReductionMeasure;
}) {
    return (
        <div className="financial-impact project-report__section">
            <div style={{ display: "flex" }}>
                <MeasureAnalysisSetting title="Id" value={measureAnalysis.id} hidden={true} />
                <MeasureAnalysisSetting
                    title="Discount Rate"
                    value={`${Math.round(measureAnalysis.discountRate * 100)}%`}
                />
                <MeasureAnalysisSetting title="Discounted to Year" value={measureAnalysis.discountedToYear} />
                <MeasureAnalysisSetting title="Start Year" value={measureAnalysis.startYear} />
                <MeasureAnalysisSetting title="End Year" value={measureAnalysis.endYear} />
                <MeasureAnalysisSetting title="Landlord Split Basis" value={measureAnalysis.landlordSplitBasis} />
                {/* <MeasureAnalysisSetting title="Basis" value={measureAnalysis.measureCostBasis} /> */}
            </div>
            <div>
                <div className="small-cards">
                    <ImpactCard displayKey="netPresentValue" value={measureAnalysis.netPresentValue} />
                    <ImpactCard displayKey="internalRateOfReturn" value={measureAnalysis.internalRateOfReturn} />
                    <ImpactCard displayKey="returnOnInvestment" value={measureAnalysis.returnOnInvestment} />
                    <ImpactCard displayKey="simplePayback" value={measureAnalysis.simplePaybackYears} />
                    <ImpactCard
                        displayKey="marginalAbatementCost"
                        // value={measure.marginalAbatementCostTotal}
                        value={measureAnalysis.marginalAbatementCost}
                    />
                </div>
            </div>
            <div>
                <TotalCostAndSavingsCard measure={measure} measureAnalysis={measureAnalysis} />
                <MeasureAnnualCashFlowChartRecommendations measure={measure} measureAnalysis={measureAnalysis} />
            </div>
        </div>
    );
}

export default MeasureAnalysis;
